import { jsx as r } from "react/jsx-runtime";
function t(n) {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: "16",
      height: "14",
      viewBox: "0 0 16 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ r(
        "path",
        {
          d: "M14.0002 1.5C14.0002 0.946875 14.4471 0.5 15.0002 0.5C15.5533 0.5 16.0002 0.946875 16.0002 1.5V6.5C16.0002 8.15625 14.6564 9.5 13.0002 9.5H3.41582L5.70957 11.7937C6.1002 12.1844 6.1002 12.8188 5.70957 13.2094C5.31895 13.6 4.68457 13.6 4.29395 13.2094L0.293945 9.20938C-0.0966797 8.81875 -0.0966797 8.18437 0.293945 7.79375L4.29395 3.79375C4.68457 3.40312 5.31895 3.40312 5.70957 3.79375C6.1002 4.18437 6.1002 4.81875 5.70957 5.20937L3.41582 7.5H13.0002C13.5533 7.5 14.0002 7.05312 14.0002 6.5V1.5Z",
          fill: "rgb(var(--background-secondary))"
        }
      )
    }
  );
}
export {
  t as ArrowTurnDownLeftIcon
};
